import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen, Printer } from "lucide-react";

const PICTOGRAPH_PATHS = {"alap":"M 118 47 L 116 45 L 113 45 L 111 47 L 110 52 L 106 60 L 101 66 L 94 70 L 84 70 L 77 66 L 76 64 L 70 60 L 61 58 L 56 55 L 50 44 L 48 34 L 49 29 L 48 27 L 43 27 L 42 28 L 42 49 L 44 54 L 49 59 L 50 64 L 46 67 L 40 77 L 40 86 L 38 90 L 34 109 L 35 114 L 39 117 L 43 118 L 55 113 L 72 103 L 75 103 L 78 101 L 84 93 L 85 82 L 87 80 L 93 80 L 94 81 L 105 75 L 110 70 L 116 57 Z M 66 68 L 77 79 L 76 89 L 71 94 L 63 97 L 54 104 L 52 104 L 48 108 L 43 108 L 42 103 L 44 99 L 44 96 L 46 94 L 49 77 L 59 67 Z","ayin":"M 27 72 L 28 76 L 35 83 L 43 88 L 51 90 L 85 90 L 86 89 L 91 89 L 102 83 L 106 76 L 108 75 L 107 71 L 97 62 L 80 57 L 73 57 L 72 56 L 59 56 L 58 57 L 53 57 L 50 59 L 42 60 L 35 64 Z M 35 72 L 40 67 L 45 65 L 49 68 L 50 73 L 52 75 L 64 80 L 68 79 L 69 80 L 79 77 L 85 72 L 85 68 L 87 66 L 92 66 L 99 72 L 99 75 L 96 78 L 88 82 L 80 84 L 52 84 L 41 80 L 36 76 Z M 54 65 L 58 62 L 64 62 L 65 61 L 76 62 L 80 65 L 80 68 L 75 72 L 63 73 L 59 72 L 55 68 Z","bayt":"M 56 59 L 56 82 L 57 83 L 56 95 L 57 96 L 75 96 L 76 97 L 90 97 L 91 96 L 97 96 L 98 97 L 99 96 L 100 97 L 109 97 L 111 95 L 111 83 L 109 75 L 109 58 L 108 57 L 103 58 L 102 57 L 95 57 L 94 58 L 78 57 L 76 59 L 76 80 L 77 81 L 88 81 L 89 78 L 88 77 L 88 68 L 91 65 L 99 65 L 101 68 L 100 86 L 97 88 L 94 87 L 67 88 L 65 86 L 65 61 L 66 60 L 63 57 L 58 57 Z","chat":"M 42 54 L 42 60 L 43 61 L 48 61 L 50 63 L 50 76 L 48 78 L 43 78 L 42 79 L 42 85 L 44 87 L 49 86 L 72 87 L 73 88 L 76 87 L 83 87 L 84 88 L 90 88 L 91 87 L 116 88 L 120 87 L 119 86 L 120 85 L 119 82 L 120 78 L 119 77 L 113 78 L 111 76 L 111 70 L 110 69 L 110 63 L 113 61 L 118 62 L 119 60 L 119 54 L 117 52 L 114 53 L 54 53 L 53 52 L 44 52 Z M 86 62 L 98 62 L 100 65 L 99 76 L 97 78 L 86 78 L 84 76 L 85 73 L 84 64 Z M 58 63 L 59 62 L 74 62 L 75 63 L 75 75 L 72 78 L 70 77 L 61 79 L 58 76 Z","dalat":"M 37 66 L 38 67 L 56 67 L 57 68 L 57 88 L 58 89 L 88 89 L 89 90 L 92 89 L 92 81 L 91 80 L 92 79 L 90 69 L 94 66 L 96 67 L 109 67 L 111 65 L 111 61 L 108 59 L 101 59 L 100 60 L 94 60 L 93 59 L 83 59 L 82 60 L 77 59 L 76 60 L 73 59 L 72 60 L 71 59 L 70 60 L 67 59 L 66 60 L 64 59 L 56 59 L 55 60 L 38 59 Z M 64 69 L 66 67 L 82 67 L 84 69 L 83 73 L 84 77 L 80 81 L 67 81 L 64 79 Z","gamal":"M 62 46 L 61 47 L 61 103 L 63 105 L 64 104 L 79 104 L 80 105 L 102 106 L 104 109 L 102 110 L 102 115 L 101 116 L 103 116 L 104 114 L 108 114 L 111 111 L 113 112 L 116 109 L 119 109 L 117 109 L 114 106 L 110 107 L 109 110 L 106 108 L 108 102 L 107 101 L 107 82 L 105 80 L 86 81 L 84 79 L 85 77 L 84 47 L 82 46 Z M 72 55 L 74 55 L 76 57 L 76 90 L 77 91 L 95 91 L 97 93 L 95 96 L 72 96 L 69 93 L 69 58 Z","ha":"M 38 52 L 37 53 L 37 77 L 39 78 L 40 77 L 49 77 L 50 78 L 55 77 L 59 80 L 59 87 L 48 98 L 49 102 L 53 105 L 57 105 L 63 98 L 65 98 L 72 105 L 74 105 L 80 101 L 83 104 L 88 104 L 89 103 L 88 100 L 90 99 L 89 95 L 91 93 L 87 92 L 85 90 L 89 89 L 90 86 L 82 85 L 81 86 L 83 86 L 84 88 L 81 90 L 85 93 L 85 95 L 84 96 L 79 95 L 74 90 L 71 89 L 69 85 L 69 81 L 71 78 L 78 78 L 79 79 L 91 79 L 92 78 L 91 52 L 84 51 L 81 53 L 82 60 L 81 61 L 81 68 L 79 70 L 71 70 L 70 69 L 70 66 L 75 62 L 77 58 L 77 50 L 74 45 L 69 42 L 58 42 L 52 50 L 52 59 L 59 66 L 58 70 L 49 70 L 46 65 L 46 52 Z M 84 100 L 85 99 L 86 100 L 85 101 Z M 84 88 L 85 87 L 86 89 L 85 90 Z M 62 50 L 66 50 L 68 52 L 68 56 L 66 58 L 62 58 L 60 56 L 60 52 Z","kap":"M 92 48 L 86 49 L 86 81 L 85 85 L 79 92 L 67 94 L 66 95 L 67 102 L 72 102 L 83 99 L 90 93 L 94 86 L 94 79 L 95 78 L 94 74 L 95 73 L 94 71 L 94 49 Z M 76 48 L 70 49 L 70 58 L 71 59 L 70 70 L 71 71 L 69 78 L 71 80 L 74 80 L 78 78 L 78 49 Z M 53 48 L 52 49 L 52 54 L 53 55 L 52 56 L 52 78 L 53 79 L 60 79 L 60 49 L 59 48 Z M 36 48 L 34 49 L 34 54 L 35 55 L 35 84 L 37 90 L 43 97 L 48 100 L 61 102 L 63 95 L 60 93 L 50 92 L 44 86 L 43 74 L 42 73 L 42 53 L 43 50 L 41 48 Z","lamad":"M 95 41 L 89 40 L 88 45 L 84 53 L 84 58 L 82 60 L 82 64 L 79 70 L 75 85 L 70 94 L 67 97 L 63 99 L 58 99 L 54 96 L 51 91 L 51 79 L 55 74 L 55 71 L 54 70 L 48 70 L 43 81 L 43 90 L 45 93 L 46 98 L 52 106 L 54 107 L 67 107 L 77 99 L 80 92 L 80 88 L 82 85 L 83 79 L 85 76 L 85 73 L 87 70 L 88 63 L 95 45 Z","mam":"M 33 81 L 33 84 L 41 84 L 44 79 L 44 76 L 46 74 L 46 72 L 48 70 L 50 70 L 52 72 L 56 83 L 66 84 L 68 82 L 72 72 L 74 70 L 76 70 L 79 73 L 82 82 L 84 84 L 90 85 L 94 83 L 99 74 L 99 72 L 101 70 L 103 70 L 111 84 L 115 85 L 120 84 L 109 66 L 107 60 L 103 59 L 97 60 L 97 62 L 89 75 L 85 73 L 80 60 L 78 59 L 72 59 L 69 62 L 64 73 L 62 75 L 60 75 L 58 73 L 56 65 L 52 59 L 45 59 L 40 68 L 40 70 Z","nun":"M 58 41 L 56 46 L 56 51 L 57 54 L 64 59 L 67 69 L 72 74 L 77 75 L 80 77 L 87 78 L 92 84 L 92 88 L 95 93 L 95 97 L 97 101 L 102 101 L 103 100 L 103 94 L 98 80 L 91 70 L 85 68 L 76 68 L 72 63 L 71 54 L 74 49 L 74 46 L 72 42 L 65 39 L 62 39 Z","pey":"M 21 76 L 24 79 L 34 83 L 49 86 L 73 86 L 78 85 L 81 83 L 86 83 L 88 81 L 94 79 L 95 75 L 92 72 L 86 69 L 73 66 L 44 66 L 36 68 L 30 71 L 27 71 L 23 73 Z M 35 75 L 37 73 L 46 73 L 47 72 L 73 72 L 74 73 L 81 73 L 83 75 L 83 77 L 80 79 L 72 79 L 71 80 L 49 80 L 48 79 L 36 78 Z","qof":"M 102 88 L 102 92 L 104 91 L 108 94 L 109 93 L 119 93 L 121 91 L 120 87 L 112 82 L 109 82 Z M 109 84 L 110 89 L 107 91 L 105 88 Z M 50 66 L 50 72 L 51 73 L 71 73 L 74 74 L 78 81 L 86 86 L 98 84 L 102 80 L 102 77 L 105 74 L 127 74 L 129 72 L 128 65 L 105 65 L 98 56 L 91 53 L 87 53 L 79 57 L 74 65 L 70 66 L 67 65 L 51 65 Z M 84 75 L 86 73 L 92 73 L 94 76 L 92 78 L 87 78 Z M 85 64 L 88 61 L 92 61 L 94 63 L 92 66 L 87 66 Z","rash":"M 64 45 L 64 56 L 59 63 L 59 66 L 56 70 L 56 74 L 59 79 L 63 82 L 71 92 L 71 94 L 74 98 L 74 104 L 82 104 L 83 101 L 82 96 L 80 94 L 76 84 L 65 73 L 69 64 L 72 61 L 84 64 L 87 67 L 88 70 L 91 73 L 91 77 L 93 78 L 96 84 L 98 102 L 102 104 L 107 104 L 108 103 L 108 98 L 106 94 L 106 90 L 108 84 L 109 71 L 112 61 L 111 54 L 94 37 L 75 40 Z M 73 50 L 75 48 L 92 47 L 102 57 L 103 59 L 102 65 L 99 68 L 91 56 L 75 54 L 73 52 Z","samek":"M 104 78 L 106 85 L 109 86 L 109 82 L 107 80 L 108 78 Z M 55 63 L 56 68 L 59 69 L 69 63 L 77 61 L 79 63 L 79 65 L 73 69 L 64 72 L 64 76 L 67 78 L 78 71 L 81 71 L 82 75 L 76 79 L 74 79 L 72 81 L 73 84 L 79 83 L 83 80 L 87 80 L 97 98 L 102 98 L 105 94 L 105 91 L 98 84 L 97 81 L 94 79 L 95 75 L 105 72 L 104 67 L 103 66 L 98 67 L 93 71 L 90 71 L 88 69 L 89 66 L 102 61 L 104 59 L 103 57 L 98 56 L 88 62 L 86 62 L 84 60 L 84 58 L 86 56 L 94 53 L 96 51 L 101 51 L 102 50 L 101 45 L 98 44 L 94 45 Z","shin":"M 40 61 L 40 95 L 41 96 L 60 96 L 61 97 L 69 97 L 70 96 L 92 96 L 93 97 L 102 97 L 103 96 L 104 97 L 105 96 L 111 96 L 112 97 L 116 95 L 116 60 L 115 59 L 108 59 L 108 84 L 109 85 L 105 89 L 104 88 L 89 88 L 87 89 L 83 86 L 84 61 L 79 59 L 76 60 L 76 86 L 72 89 L 71 88 L 53 88 L 51 89 L 48 86 L 48 61 L 47 60 L 41 60 Z","tat":"M 61 47 L 52 59 L 52 64 L 51 65 L 51 78 L 55 88 L 61 94 L 70 98 L 86 99 L 96 97 L 100 95 L 107 86 L 110 75 L 109 66 L 105 56 L 96 47 L 88 45 L 85 43 L 69 43 Z M 69 86 L 78 77 L 80 77 L 89 87 L 85 90 L 77 90 L 76 89 L 71 89 Z M 96 60 L 99 64 L 100 69 L 99 78 L 96 82 L 89 73 L 87 72 L 87 69 Z M 64 60 L 73 70 L 62 81 L 59 78 L 59 67 L 60 63 Z M 71 52 L 78 52 L 79 51 L 80 52 L 87 52 L 89 54 L 89 56 L 81 64 L 78 64 L 70 56 Z","tau":"M 74 42 L 72 44 L 73 58 L 70 61 L 68 60 L 59 60 L 58 61 L 58 66 L 59 67 L 71 67 L 73 69 L 72 72 L 72 98 L 74 100 L 77 100 L 80 98 L 80 68 L 83 66 L 84 67 L 85 66 L 86 67 L 94 67 L 94 61 L 93 60 L 82 60 L 80 58 L 81 43 Z","tsade":"M 14 64 L 14 70 L 13 71 L 16 81 L 20 86 L 28 90 L 33 90 L 41 87 L 45 80 L 49 79 L 58 88 L 65 91 L 71 87 L 72 84 L 75 81 L 78 72 L 82 70 L 88 79 L 88 82 L 92 88 L 92 91 L 95 93 L 99 92 L 99 87 L 97 85 L 90 69 L 84 63 L 77 62 L 74 65 L 71 74 L 66 81 L 60 80 L 57 76 L 52 73 L 46 67 L 43 60 L 35 54 L 26 54 L 20 56 Z M 24 64 L 33 63 L 38 69 L 38 75 L 31 80 L 25 79 L 22 75 L 22 68 Z","uau":"M 58 43 L 55 45 L 55 49 L 65 67 L 65 89 L 64 92 L 65 94 L 73 94 L 74 93 L 73 90 L 74 89 L 74 83 L 73 82 L 74 72 L 73 70 L 75 66 L 75 63 L 79 59 L 84 47 L 82 45 L 78 44 L 72 55 L 69 57 L 66 54 L 63 45 L 61 43 Z","yad":"M 106 53 L 99 53 L 98 54 L 98 80 L 95 82 L 63 81 L 45 70 L 41 75 L 41 77 L 50 81 L 54 85 L 54 87 L 41 95 L 40 97 L 44 102 L 49 100 L 59 92 L 67 89 L 69 90 L 106 90 Z","zayin":"M 37 73 L 42 79 L 44 79 L 55 69 L 63 65 L 75 62 L 77 64 L 77 73 L 75 75 L 60 75 L 59 76 L 59 84 L 60 85 L 111 86 L 116 85 L 119 82 L 118 81 L 118 75 L 88 75 L 86 73 L 86 65 L 88 62 L 109 62 L 110 60 L 109 59 L 109 53 L 70 53 L 60 56 L 58 58 L 55 58 L 41 68 Z"};
const PICTOGRAPH_KEYS = ["alap","bayt","gamal","dalat","ha","uau","zayin","chat","tat","yad","kap","lamad","mam","nun","samek","ayin","pey","tsade","qof","rash","shin","tau"];

const letters = [
  {
    "name": "ALaP",
    "common": "Aleph",
    "paleo": "𐤀",
    "modern": "א",
    "written": "A",
    "sound": "ah",
    "number": "1",
    "picture": "Ox head",
    "meaning": "Strong leader · first",
    "pictoPosition": "0% 0%"
  },
  {
    "name": "BaYaT",
    "common": "Bet",
    "paleo": "𐤁",
    "modern": "ב",
    "written": "B",
    "sound": "ba / b",
    "number": "2",
    "picture": "House / tent",
    "meaning": "House · household · inside",
    "pictoPosition": "20% 0%"
  },
  {
    "name": "GaMaL",
    "common": "Gimel",
    "paleo": "𐤂",
    "modern": "ג",
    "written": "G",
    "sound": "ga / g",
    "number": "3",
    "picture": "Foot / camel",
    "meaning": "Walk · carry · lift",
    "pictoPosition": "40% 0%"
  },
  {
    "name": "DaLaT",
    "common": "Dalet",
    "paleo": "𐤃",
    "modern": "ד",
    "written": "D",
    "sound": "da / d",
    "number": "4",
    "picture": "Tent door",
    "meaning": "Door · entrance · pathway",
    "pictoPosition": "60% 0%"
  },
  {
    "name": "Ha",
    "common": "Hey",
    "paleo": "𐤄",
    "modern": "ה",
    "written": "H",
    "sound": "ha / h",
    "number": "5",
    "picture": "Raised arms / breath",
    "meaning": "Behold · reveal · breath",
    "pictoPosition": "80% 0%"
  },
  {
    "name": "UaU",
    "common": "Waw",
    "paleo": "𐤅",
    "modern": "ו",
    "written": "U/W",
    "sound": "u / w",
    "number": "6",
    "picture": "Nail / peg",
    "meaning": "Secure · connect · fasten",
    "pictoPosition": "100% 0%"
  },
  {
    "name": "ZaYaN",
    "common": "Zayin",
    "paleo": "𐤆",
    "modern": "ז",
    "written": "Z",
    "sound": "za / z",
    "number": "7",
    "picture": "Plow / weapon",
    "meaning": "Cut · provide · tool",
    "pictoPosition": "0% 33.333333333333336%"
  },
  {
    "name": "ChaT",
    "common": "Het",
    "paleo": "𐤇",
    "modern": "ח",
    "written": "Ch",
    "sound": "cha / ch",
    "number": "8",
    "picture": "Tent wall / fence",
    "meaning": "Separate · protect · fence",
    "pictoPosition": "20% 33.333333333333336%"
  },
  {
    "name": "TaT",
    "common": "Tet",
    "paleo": "𐤈",
    "modern": "ט",
    "written": "T",
    "sound": "ta / t",
    "number": "9",
    "picture": "Basket / enclosure",
    "meaning": "Surround · contain",
    "pictoPosition": "40% 33.333333333333336%"
  },
  {
    "name": "YaD",
    "common": "Yod",
    "paleo": "𐤉",
    "modern": "י",
    "written": "Y",
    "sound": "ya / y",
    "number": "10",
    "picture": "Arm / hand",
    "meaning": "Work · deed · hand",
    "pictoPosition": "60% 33.333333333333336%"
  },
  {
    "name": "KaP",
    "common": "Kaph",
    "paleo": "𐤊",
    "modern": "כ",
    "written": "K",
    "sound": "ka / k",
    "number": "20",
    "picture": "Palm of hand",
    "meaning": "Open · bend · palm",
    "pictoPosition": "80% 33.333333333333336%"
  },
  {
    "name": "LaMaD",
    "common": "Lamed",
    "paleo": "𐤋",
    "modern": "ל",
    "written": "L",
    "sound": "la / l",
    "number": "30",
    "picture": "Staff",
    "meaning": "Teach · guide · learn",
    "pictoPosition": "100% 33.333333333333336%"
  },
  {
    "name": "MaM",
    "common": "Mem",
    "paleo": "𐤌",
    "modern": "מ",
    "written": "M",
    "sound": "ma / m",
    "number": "40",
    "picture": "Water",
    "meaning": "Water · flow · many",
    "pictoPosition": "0% 66.66666666666667%"
  },
  {
    "name": "NaN",
    "common": "Nun",
    "paleo": "𐤍",
    "modern": "נ",
    "written": "N",
    "sound": "na / n",
    "number": "50",
    "picture": "Seed / fish",
    "meaning": "Seed · continue · life",
    "pictoPosition": "20% 66.66666666666667%"
  },
  {
    "name": "SaMaK",
    "common": "Samek",
    "paleo": "𐤎",
    "modern": "ס",
    "written": "S",
    "sound": "sa / s",
    "number": "60",
    "picture": "Hand on staff",
    "meaning": "Support · prop · uphold",
    "pictoPosition": "40% 66.66666666666667%"
  },
  {
    "name": "AYaN",
    "common": "Ayin",
    "paleo": "𐤏",
    "modern": "ע",
    "written": "A",
    "sound": "ah / ay",
    "number": "70",
    "picture": "Eye",
    "meaning": "See · watch · experience",
    "pictoPosition": "60% 66.66666666666667%"
  },
  {
    "name": "Pa",
    "common": "Pe",
    "paleo": "𐤐",
    "modern": "פ",
    "written": "P",
    "sound": "pa / p",
    "number": "80",
    "picture": "Mouth",
    "meaning": "Mouth · word · speak",
    "pictoPosition": "80% 66.66666666666667%"
  },
  {
    "name": "TzaD",
    "common": "Tsade",
    "paleo": "𐤑",
    "modern": "צ",
    "written": "Tz",
    "sound": "tza / ts",
    "number": "90",
    "picture": "Man on side",
    "meaning": "Desire · need · pursuit",
    "pictoPosition": "100% 66.66666666666667%"
  },
  {
    "name": "QaP",
    "common": "Qoph",
    "paleo": "𐤒",
    "modern": "ק",
    "written": "Q",
    "sound": "qa / q",
    "number": "100",
    "picture": "Sun on horizon",
    "meaning": "Behind · cycle · horizon",
    "pictoPosition": "0% 100%"
  },
  {
    "name": "RaSh",
    "common": "Resh",
    "paleo": "𐤓",
    "modern": "ר",
    "written": "R",
    "sound": "ra / r",
    "number": "200",
    "picture": "Head",
    "meaning": "Head · person · first",
    "pictoPosition": "20% 100%"
  },
  {
    "name": "ShaN",
    "common": "Shin",
    "paleo": "𐤔",
    "modern": "ש",
    "written": "Sh",
    "sound": "sha / sh",
    "number": "300",
    "picture": "Teeth",
    "meaning": "Eat · consume · press",
    "pictoPosition": "40% 100%"
  },
  {
    "name": "TaU",
    "common": "Taw",
    "paleo": "𐤕",
    "modern": "ת",
    "written": "T",
    "sound": "ta / t",
    "number": "400",
    "picture": "Mark / sign",
    "meaning": "Mark · sign · agreement",
    "pictoPosition": "60% 100%"
  }
];

export default function AlapBayt(){
  return (
    <div className="min-h-screen bg-[#fff8ed]" data-testid="alap-bayt-page">
      <section className="border-b-4 border-kingdom-gold bg-royal-blue py-12 text-white">
        <div className="mx-auto max-w-5xl px-4 sm:px-6">
          <Link to="/free-resources" className="inline-flex items-center text-sm font-bold text-kingdom-gold">
            <ArrowLeft className="mr-2 h-4 w-4"/>Free Resources
          </Link>
          <h1 className="mt-4 font-heading text-4xl font-black sm:text-5xl">Ancient Abaryt Alap Bayt</h1>
          <p className="mt-4 max-w-3xl text-lg leading-relaxed text-white/85">
            The ancient pictograph is the primary form on this page. Paleo script and the later modern Hebrew form are shown underneath so learners can recognize how each letter appears across the different written forms.
          </p>
          <div className="mt-6 flex flex-wrap gap-2 text-xs font-black uppercase tracking-wider text-royal-blue">
            {["Ancient pictograph first", "Paleo form", "Modern form", "Sound", "Meaning", "Number"].map(item => <span key={item} className="bg-kingdom-gold px-3 py-2">{item}</span>)}
          </div>
        </div>
      </section>

      <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6">
        <div className="mb-9 border-l-4 border-kingdom-gold bg-white p-6 shadow-sm">
          <BookOpen className="h-7 w-7 text-kingdom-gold"/>
          <h2 className="mt-3 font-heading text-2xl font-black text-royal-blue">Pictograph takes the stage</h2>
          <p className="mt-2 leading-relaxed text-slate-600">
            Start with the pictured ancient form. Then compare it to the Paleo script and the later modern Hebrew form. Say the name and sound, connect the picture meaning, and learn the number.
          </p>
        </div>

        <div className="space-y-10">
          {letters.map((letter,index) => (
            <article key={letter.name} className="overflow-hidden bg-white shadow-md ring-1 ring-black/5" data-testid={`alap-bayt-letter-${index+1}`}>
              <div className="grid md:grid-cols-[330px_1fr]">
                <div className="bg-gradient-to-br from-[#f7d66d] via-[#fff2bd] to-[#f3b7cf] p-6">
                  <div className="text-center text-[11px] font-black uppercase tracking-[.2em] text-royal-blue">Ancient pictograph</div>
                  <div className="mx-auto mt-4 flex aspect-[150/130] w-full max-w-[280px] items-center justify-center">
                    <svg
                      viewBox="0 0 150 130"
                      className="h-full w-full"
                      role="img"
                      aria-label={`${letter.name} ancient pictograph`}
                    >
                      <path
                        d={PICTOGRAPH_PATHS[PICTOGRAPH_KEYS[index]]}
                        fill="currentColor"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        className="text-[#1f160d]"
                      />
                    </svg>
                  </div>
                  <div className="mt-5 text-center">
                    <h2 className="font-heading text-3xl font-black text-royal-blue">{letter.name}</h2>
                    <p className="mt-1 text-sm font-bold text-royal-blue/70">{letter.picture}</p>
                  </div>
                </div>

                <div className="p-6 sm:p-8">
                  <div className="grid grid-cols-2 gap-3">
                    <div className="border-2 border-royal-blue/10 bg-[#fff8ed] p-4 text-center">
                      <div className="text-[10px] font-black uppercase tracking-[.18em] text-slate-500">Paleo script</div>
                      <div className="mt-2 text-6xl leading-none text-royal-blue">{letter.paleo}</div>
                      <div className="mt-2 text-xs font-bold text-slate-500">{letter.common}</div>
                    </div>
                    <div className="border-2 border-slate-200 bg-slate-50 p-4 text-center">
                      <div className="text-[10px] font-black uppercase tracking-[.18em] text-slate-500">Later modern Hebrew</div>
                      <div className="mt-2 text-6xl leading-none text-slate-700">{letter.modern}</div>
                      <div className="mt-2 text-xs font-bold text-slate-500">recognition only</div>
                    </div>
                  </div>

                  <div className="mt-6 grid gap-3 sm:grid-cols-2">
                    <div className="border-l-4 border-kingdom-gold bg-[#fff8ed] p-4"><div className="text-xs font-black uppercase tracking-wider text-slate-500">Sound</div><div className="mt-1 text-xl font-bold text-royal-blue">{letter.sound}</div></div>
                    <div className="border-l-4 border-kingdom-gold bg-[#fff8ed] p-4"><div className="text-xs font-black uppercase tracking-wider text-slate-500">Number</div><div className="mt-1 text-xl font-bold text-royal-blue">{letter.number}</div></div>
                    <div className="border-l-4 border-kingdom-gold bg-[#fff8ed] p-4 sm:col-span-2"><div className="text-xs font-black uppercase tracking-wider text-slate-500">Picture meaning</div><div className="mt-1 text-xl font-bold text-royal-blue">{letter.meaning}</div></div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <section className="mt-12 bg-royal-blue p-7 text-white">
          <h2 className="font-heading text-2xl font-black">Quick form comparison</h2>
          <p className="mt-2 text-white/75">Use this strip to compare the Paleo and modern forms after learning the pictograph above.</p>
          <div className="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-4 md:grid-cols-6">
            {letters.map(letter => (
              <div key={letter.name} className="bg-white p-3 text-center text-royal-blue">
                <div className="text-xs font-black">{letter.name}</div>
                <div className="mt-2 flex items-center justify-center gap-3 text-2xl"><span>{letter.paleo}</span><span className="text-slate-400">→</span><span>{letter.modern}</span></div>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12 border-2 border-dashed border-kingdom-gold bg-white p-7">
          <Printer className="h-8 w-8 text-kingdom-gold"/>
          <h2 className="mt-3 font-heading text-2xl font-black text-royal-blue">Next resource layer</h2>
          <p className="mt-2 text-slate-600">
            Tracing sheets, pictograph-to-Paleo matching, pictograph-to-modern recognition, sound drills, flashcards and number matching can now use the exact same three-form structure.
          </p>
        </section>
      </main>
    </div>
  );
}
